(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LanguageDetailController', LanguageDetailController);

    LanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Language', 'Patient', 'Corporation'];

    function LanguageDetailController($scope, $rootScope, $stateParams, previousState, entity, Language, Patient, Corporation) {
        var vm = this;

        vm.language = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:languageUpdate', function(event, result) {
            vm.language = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
